import { connect } from 'react-redux';
import StationPriceReport from './StationPriceReport';
import { submitPriceReport, resetPriceReportStatus } from '../../actions/fuelReport';

const mapStateToProps = ({ auth, fuelReport, user }) => ({
  isLoggedIn: !!auth.account_id,
  isPosting: fuelReport.isPosting,
  fuelsPosted: fuelReport.fuelsPosted,
  postError: fuelReport.error,
  pointsAwarded: fuelReport.pointsAwarded,
  memberName: user.name,
  canSetMemberName: user.tags?.generatedMembername || false,
});

const mapDispatchToProps = dispatch => ({
  submitPriceReport: (stationId, options) => dispatch(submitPriceReport(stationId, options)),
  resetPriceReportStatus: () => dispatch(resetPriceReportStatus()),
});

export default connect(mapStateToProps, mapDispatchToProps)(StationPriceReport);
